import { render, staticRenderFns } from "./PurchaseReconciliation.vue?vue&type=template&id=8ba1a0c8&scoped=true&lang=pug&"
import script from "./PurchaseReconciliation.vue?vue&type=script&setup=true&lang=js&"
export * from "./PurchaseReconciliation.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./PurchaseReconciliation.vue?vue&type=style&index=0&id=8ba1a0c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba1a0c8",
  null
  
)

export default component.exports